var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_129_2100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7388 16.4139C21.5716 17.6843 20.9477 18.8503 19.9837 19.6943C19.0196 20.5383 17.7813 21.0025 16.5 21.0002C9.05626 21.0002 3.00001 14.9439 3.00001 7.50018C2.99771 6.21889 3.4619 4.98057 4.30588 4.01652C5.14986 3.05246 6.31592 2.42859 7.58626 2.26143C7.9075 2.2222 8.2328 2.28792 8.51362 2.44878C8.79444 2.60963 9.0157 2.85699 9.14438 3.15393L11.1244 7.57424V7.58549C11.2229 7.81279 11.2636 8.06095 11.2428 8.30781C11.222 8.55467 11.1404 8.79254 11.0053 9.00018C10.9884 9.02549 10.9706 9.04893 10.9519 9.07236L9.00001 11.3861C9.7022 12.813 11.1947 14.2924 12.6403 14.9964L14.9222 13.0549C14.9446 13.036 14.9681 13.0185 14.9925 13.0024C15.2 12.864 15.4387 12.7795 15.687 12.7566C15.9353 12.7337 16.1854 12.773 16.4147 12.8711L16.4269 12.8767L20.8434 14.8558C21.1409 14.984 21.3889 15.2051 21.5503 15.486C21.7116 15.7668 21.7778 16.0924 21.7388 16.4139Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_129_2100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fc6dcc1005f7c135847a089263b0010c.svg";
export { ForwardRef as ReactComponent };